import { render, staticRenderFns } from "./Asignacionesv2ts.vue?vue&type=template&id=16c9a1f9"
import script from "./Asignacionesv2ts.vue?vue&type=script&lang=js"
export * from "./Asignacionesv2ts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports